// import Contador from "./components/Contador";
// import Like from "./components/Like";
import SpaceX from "./components/SpaceX";

function App() {
  return (
    <div>
      {/* <Contador />
      <Like /> */}
      <SpaceX>
        <h1>Meu Segundo Projeto React do Zero</h1>
      </SpaceX>
    </div>
  );
}

export default App;
